import React from 'react';
import { withStyles } from '@material-ui/core';
import appStoreBadge from '../../../assets/badges/appstore-badge.svg';
import playStoreBadge from '../../../assets/badges/playstore-badge.png';
import { styles } from './styles';

const StoreBadges = ({ classes }) => {
  return (
    <div className={classes.appStoreButtonsContainer}>
      <a
        href="https://play.google.com/store/apps/details?id=live.venti.customer_app"
        target="_blank"
        rel="noopener noreferrer"
        className={classes.appStoreButton}
      >
        <img
          src={playStoreBadge}
          alt="Consíguela en Google Play"
          className={classes.appStoreButtonImage}
        />
      </a>
      <a
        href="https://apps.apple.com/ar/app/venti-eventos-en-vivo/id6739432902?itscg=30200&itsct=apps_box_link&mttnsubad=6739432902"
        target="_blank"
        rel="noopener noreferrer"
        className={classes.appStoreButton}
      >
        <img
          src={appStoreBadge}
          alt="Descárgala en App Store"
          className={classes.appStoreButtonImage}
        />
      </a>
    </div>
  );
};

export default withStyles(styles)(StoreBadges);
